import { getAuth } from "firebase/auth";

function getApiBaseUrl() {
  const isLocalhost = ["localhost", "127.0.0.1"].includes(window.location.hostname);
  const fallback =
    "https://us-central1-houari-boumedienne-schoo-4d4c2.cloudfunctions.net";
  const configured = process.env.REACT_APP_API_BASE_URL || "";
  return String(isLocalhost ? configured || fallback : configured).replace(/\/+$/, "");
}

// Deleting a student has to go through the server: the browser can remove
// the Firestore record but not another user's Auth account, and an account
// left behind keeps the email taken forever.
export async function deleteStudentAccount(studentId) {
  const user = getAuth().currentUser;
  if (!user) {
    throw new Error("Please sign in again to continue.");
  }

  const response = await fetch(`${getApiBaseUrl()}/api/students/delete`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${await user.getIdToken()}`,
    },
    body: JSON.stringify({ studentId }),
  });

  const payload = (response.headers.get("content-type") || "").includes("application/json")
    ? await response.json()
    : { ok: false, error: await response.text() };

  if (!response.ok || !payload.ok) {
    throw new Error(payload.error || "Unable to delete student.");
  }
  return payload;
}
